import $ from 'jquery';

const selectors = {
  toggle: 'data-toggle-grid',
  large: 'data-grid-large',
  small: 'data-grid-small',
};

const options = {
  breakpoint: window.theme.sizes.small,
};

var sections = {};

class Toggle {
  constructor($button) {
    this.$toggle = $button;
    this.value = this.$toggle.attr(selectors.toggle);
    this._listen();
  }
  unload() {
    this.$toggle.off();
  }
  _listen() {
    this.$toggle.on('click', () => {
      const isLarge = (window.innerWidth >= options.breakpoint);
      const selector = (isLarge) ? selectors.large : selectors.small;
      $(`[${selector}]`).attr(selector, this.value);
      if (window.lazySizes) {
        window.lazySizes.autoSizer.checkElems();
      }
    });
  }
  _getContianer() {
    // find grid wrappers in the same section
    return this.$toggle
      .closest('[data-section-type]')
      .find(selectors.wrapper);
  }
}

const toggleSection = {
  onLoad() {
    sections[this.id] = [];
    const buttons = this.container.querySelectorAll(`[${selectors.toggle}]`);
    buttons.forEach(button => {
      const $button = $(button);
      sections[this.id].push(new Toggle($button));
    });
  },
  onUnload: function() {
    sections[this.id].forEach(toggle => {
      if (typeof toggle.unload === 'function') {
        toggle.unload();
      }
    });
  },
};

export default toggleSection;

